import Check from "@mui/icons-material/Check";
import type { SxProps } from "@mui/material";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { lightOrDark } from "@app/embedded/theme/utils";

import Stack from "@rui/Stack";

export const CheckboxIconWrapper = styled(Stack)(({ theme }) => ({
  border: "1px solid",
  borderRadius: "3px",
  width: "20px",
  height: "20px",
  "input:disabled ~ &": {
    backgroundColor: theme.palette.shades.neutral[100],
    opacity: "50%",
  },
  overflow: "hidden",
  "& .checkbox__icon--checked__icon": {
    padding: "3px",
  },
  "& .checkbox__icon--indeterminate__icon": {
    color: lightOrDark("#000", "#FFF")(theme),
    marginTop: "-2px",
  },
}));

interface CheckboxIconProps {
  sx?: SxProps;
}

export const UncheckedIcon = ({ sx }: CheckboxIconProps) => (
  <CheckboxIconWrapper
    className="checkbox__icon checkbox__icon--unchecked"
    variant="center"
    sx={sx}
  />
);

export const CheckedIcon = ({ sx }: CheckboxIconProps) => (
  <CheckboxIconWrapper
    className="checkbox__icon checkbox__icon--checked"
    variant="center"
    sx={sx}
  >
    <Check fontSize="medium" className="checkbox__icon--checked__icon" />
  </CheckboxIconWrapper>
);

export const IndeterminateCheckIcon = ({ sx }: CheckboxIconProps) => (
  <CheckboxIconWrapper
    className="checkbox__icon checkbox__icon--indeterminate"
    variant="center"
    sx={sx}
  >
    <Typography className="checkbox__icon--indeterminate__icon">–</Typography>
  </CheckboxIconWrapper>
);
